import axios from "axios";

const model = "sites";

export default {
  config(params) {
    return axios.get(`/api/${model}/config`, { params });
  }
};
